// sendMailSMTP.js

import { getCompanyCodeFromToken } from "./authService";
import { API_URL } from "./apiConfig";

export const SendSourcingAssignmentEmailAsync = async (newRequest) => {
  try {

    
    const response = await fetch(`${API_URL}Email/sendSourcingAssignmentEmail`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(newRequest),
    });

    if (response.ok) {
      const data = await response.json();
      return data; // success response from backend
    } else {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to send sourcing assignment email');
    }
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const sendInterviewInvitationEmailAsync = async (newRequest) => {
  try {

    
    const response = await fetch(`${API_URL}Email/sendInterviewInvitationEmail`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(newRequest),
    });

    if (response.ok) {
      const data = await response.json();
      return data; // success response from backend
    } else {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to send sourcing assignment email');
    }
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};
 
 
export const SendSubmissionEmailToHRAsync = async (newRequest) => {
  try {

    newRequest.CompanyCode =getCompanyCodeFromToken();
    const response = await fetch(`${API_URL}Email/sendSubmissionEmailToHR`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(newRequest),
    });

    if (response.ok) {
      const data = await response.json();
      return data; // success response from backend
    } else {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to send sourcing assignment email');
    }
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const SendApprovalEmailToHiringManagerAsync = async (newRequest) => {
  try {

    
    const response = await fetch(`${API_URL}Email/sendApprovalEmailToHiringManager`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(newRequest),
    });

    if (response.ok) {
      const data = await response.json();
      return data; // success response from backend
    } else {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to send sourcing assignment email');
    }
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const SendCandidateStatusEmailAsync = async (candidateStatusRequest) => {
  try {
    
    const response = await fetch(`${API_URL}Email/sendCandidateStatusEmail`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(candidateStatusRequest),
    });

    if (response.ok) {
      const data = await response.json();
      return data; // success response from backend
    } else {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to send candidate status email');
    }
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};
export const SendDirectEvaluationEmailAsync = async (candidateStatusRequest) => {
  try {
    const response = await fetch(`${API_URL}Email/sendDirectEvaluationEmail`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(candidateStatusRequest),
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to send direct evaluation email');
    }
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const SendCandidateFinalStatusEmailAsync = async (request) => {
  try {
    const response = await fetch(`${API_URL}Email/sendCandidateFinalStatus`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to send candidate final status email');
    }

    return await response.json();
  } catch (error) {
    console.error("Error sending candidate final status email:", error);
    throw error;
  }
};

export const SendApprovalWorkflowEmailAsync = async (request) => {
  try {
    const response = await fetch(`${API_URL}Email/sendApprovalWorkflowEmail`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request),
    });
    if (response.ok) return await response.json();
    throw new Error('Failed to send approval workflow email');
  } catch (error) {
    console.error("Error sending approval workflow email:", error);
  }
};
